import { useEffect } from "react";

import useWebSocket from "frontend/hooks/useWebSocket";
import { PHOTO_UPLOADS_BY_CREATOR } from "frontend/hooks/useWebSocket/paths";
import { useUploadsCurrentlyProcessing } from "frontend/components/creator-tools/PhotoUploadPage/PhotoUploadCore/hooks";

import {
    handleSuccessfulUploadEvent,
    handleFailedUploadEvent,
    handleWithdrawnUploadEvent
} from "./helpers";
import { removeOriginalFilenamePrefix } from "../../helpers";

const usePhotoUploadWebSocket = () => {
    const { removeFromCurrentlyProcessing } = useUploadsCurrentlyProcessing();

    const { openConnection, closeConnection, data } = useWebSocket(
        PHOTO_UPLOADS_BY_CREATOR
    );

    useEffect(() => {
        return () => {
            closeConnection();
        };
    }, []);

    useEffect(() => {
        if (!data) return;

        if (data.status === "WITHDRAWN_BEFORE_SUBMISSION") {
            handleWithdrawnUploadEvent(data);
        }

        if (
            data.status === "UPLOAD_FAILED" ||
            data.status === "FILE_INVALID" ||
            data.status === "FILE_CHECK_FAILED"
        ) {
            removeFromCurrentlyProcessing([
                removeOriginalFilenamePrefix(data.originalFilename)
            ]);
            handleFailedUploadEvent(data);
        }

        if (data.status === "IN_DROPZONE") {
            removeFromCurrentlyProcessing([data.originalFilename]);
            handleSuccessfulUploadEvent(data);
        }
    }, [data]);

    return {
        openConnection
    };
};

export default usePhotoUploadWebSocket;
